module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_lequ_present-6064c515b80c5bb7588d52d7ec1a3183.jpg";